<script>
  import formatarData from '~js/formatar-data';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';

  export default {
    components: { datepicker },
    props: {
      socios: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        socio: this.camposSocio(),
        totalPercentualCotas: 0.0,
      }
    },
    methods: {
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              if (this.socio.dataSaida != "") {

                const dataInicial = new Date(this.socio.dataEntrada.split('/').reverse().join('-'));
                const dataFinal = new Date(this.socio.dataSaida.split('/').reverse().join('-'));

                if (dataInicial > dataFinal) {
                  this.$swal('', 'A data de saída do sócio deve ser maior que a data de entrada.', 'error');
                  return;
                }
              }

              const socioAtivo = this.verificaSocioAtivo(this.socio);

              if (socioAtivo) {
                const socioExiste = this.verificaSocioAtivoExiste(this.socio);

                if (socioExiste) {
                  this.$swal('', 'Existe um sócio com o mesmo CPF registrado e ativo.', 'error');
                  return;
                }

                const socioPercentualCotas = parseFloat(this.socio.percentualCotas.replace(",", "."));

                if (((socioPercentualCotas + this.totalPercentualCotas) > 100)) {
                  this.$swal('', 'A porcentagem máxima de todos os sócios ativos deve ser de no máximo 100%.', 'error');
                  return;
                }
              } else {
                if (parseFloat(this.socio.percentualCotas.replace(",", ".")) > 100) {
                  this.$swal('', 'A porcentagem máxima de um sócio deve ser de no máximo 100%.', 'error');
                  return;
                }
              }

              this.adicionar();
            }
          })
      },
      validarDadosNaoEnviados(){
        if(this.socio.nome != '')
          return false;
        if(this.socio.cpf != '')
          return false
        if(this.socio.dataEntrada != '')
          return false;
        if(this.socio.dataSaida != '')
          return false
        if(this.socio.percentualCotas != '')
          return false;

        return true;
      },
      deletar(indice) {
        this.socios.splice(indice, 1);
      },
      editar(indice) {
        const socio = this.socios[indice];
        this.socios.splice(indice, 1);
        this.socio.id = socio.id;
        this.socio.nome = socio.nome;
        this.socio.cpf = socio.cpf;
        this.socio.dataEntrada = formatarData.paraData(socio.dataEntrada);
        this.socio.dataSaida = formatarData.paraData(socio.dataSaida);
        this.socio.percentualCotas = socio.percentualCotas.toString();
      },
      async adicionar() {
        const copiaSocio = Object.assign(this.socio);

        copiaSocio.dataEntrada = await formatarData.paraNumero(copiaSocio.dataEntrada);

        if (copiaSocio.dataSaida) {
          copiaSocio.dataSaida = await formatarData.paraNumero(copiaSocio.dataSaida);
        }

        this.socio = this.camposSocio();

        this.socios.push(copiaSocio);

        this.$validator.reset();
      },
      somaPercentualCotasAtivas() {
        this.totalPercentualCotas = 0.0;
        for (const socio of this.socios) {
          if (this.verificaSocioAtivo(socio)) {
            this.totalPercentualCotas += parseFloat(socio.percentualCotas.toString().replace(",", "."))
          }
        }
      },
      verificaSocioAtivoExiste(socio) {
        for (const socioAux of this.socios) {
          if (socioAux.cpf == socio.cpf) {
            return this.verificaSocioAtivo(socioAux);
          }
        }
        return false;
      },
      verificaSocioAtivo(socio) {
        if (socio.dataSaida) {
          let dataSaidaSocio = typeof (socio.dataSaida) == "number" ? formatarData.paraData(socio.dataSaida) : socio.dataSaida;
          dataSaidaSocio = Date.parse(dataSaidaSocio.split('/').reverse().join('-'));

          let dataAtual = new Date().toLocaleDateString('pt-BR');
          dataAtual = Date.parse(dataAtual.split('/').reverse().join('-'));

          const ativo = dataAtual <= dataSaidaSocio

          return ativo;
        }
        return true;
      },
      camposSocio() {
        return {
          id: '',
          dataEntrada: '',
          dataSaida: '',
          nome: '',
          cpf: '',
          percentualCotas: '',
        }
      }
    },
    watch: {
      socios: {
        handler() {
          this.somaPercentualCotasAtivas();
        },
        immediate: true
      }
    }
  }
</script>

<template>
  <div>

    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>Data de entrada</th>
            <th>Data de saida</th>
            <th>% Cotas</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(socio, indice) in socios">
            <td>{{ socio.nome }}</td>
            <td>{{ socio.cpf }}</td>
            <td>{{ socio.dataEntrada | formatarNumeroEmData }}</td>
            <td>{{ socio.dataSaida | formatarNumeroEmData('---') }}</td>
            <td>{{ socio.percentualCotas }} {{verificaSocioAtivo(socio) ? "" : " (Inativo)"}}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="socios.length > 0">
            <td colspan="3"></td>
            <td><strong>Total % Cotas Ativas:</strong> </td>
            <td><strong>{{ totalPercentualCotas }}</strong></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-if="socios.length === 0">
            <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <div class="form-group required" :class="{'has-error': errors.has('nome')}">
          <label class="control-label" for="nome">Nome</label>

          <input type="text"
                 class="form-control"
                 id="nome"
                 maxlength="60"
                 v-model="socio.nome"
                 data-vv-name="nome"
                 data-vv-as="nome"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nome')">{{ errors.first('nome') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('cpf')}">
          <label class="control-label" for="cpf">CPF</label>

          <input type="text"
                 class="form-control"
                 id="cpf"
                 v-model="socio.cpf"
                 v-mascara="'cpf'"
                 data-vv-name="cpf"
                 data-vv-as="cpf"
                 v-validate="'required|cpf'">

          <p class="text-danger" v-show="errors.has('cpf')">{{ errors.first('cpf') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('dataEntrada')}">
          <label class="control-label" for="data-entrada">Data de entrada</label>

          <datepicker v-model="socio.dataEntrada"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataEntrada"
                      data-vv-as="data de entrada"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataEntrada')">{{ errors.first('dataEntrada') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group" :class="{'has-error': errors.has('dataSaida')}">
          <label class="control-label" for="data-saida">Data de saída</label>

          <datepicker v-model="socio.dataSaida"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataSaida"
                      data-vv-as="data de saída"
                      v-validate="'date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataSaida')">{{ errors.first('dataSaida') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('percentualCotas')}">
          <label class="control-label" for="percentual-cotas">Percentual Cotas</label>

          <input type="text"
                 class="form-control text-center"
                 id="percentual-cotas"
                 v-model="socio.percentualCotas"
                 v-mascara="'porcentagem'"
                 maxlength="5"
                 data-vv-name="percentualCotas"
                 data-vv-as="percentual cotas"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('percentualCotas')">{{ errors.first('percentualCotas') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <button type="button"
                  class="btn btn-success"
                  @click="validar">
            <i class="fa fa-plus"></i> Adicionar sócio
          </button>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/compartilhado/FormSocios.vue